(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    class ProductCardVariants extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('.product-grid-item');

      const dataScript = this.querySelector('script[data-card-variants]');
      try {
        this.variants = dataScript ? JSON.parse(dataScript.textContent) : [];
      } catch (error) {
        this.variants = [];
      }

      this.addEventListener('change', this.handleChange);
      this.updateOptionAvailability();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleChange);
    }

    get selectedValues() {
      return Array.from(this.querySelectorAll('fieldset')).map((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    handleChange = () => {
      this.updateOptionAvailability();

      const values = this.selectedValues;
      const variant = this.variants.find(
        (candidate) =>
          candidate.options.length === values.length &&
          candidate.options.every((option, index) => option === values[index])
      );
      console.log('Selected variant:', variant);

      if (!variant) return;

      this.updateVariantId(variant);
      this.updateImage(variant);
      this.updatePrice(variant);
      this.updateButton(variant);
    };

    /**
     * Marks each option value as available/unavailable based on the other
     * currently-selected options, so the 45-degree slash reflects the live selection.
     */
    updateOptionAvailability() {
      const selected = this.selectedValues;
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));

      fieldsets.forEach((fieldset, optionIndex) => {
        const labels = fieldset.querySelectorAll('.product-grid-item__option-pill');

        labels.forEach((label) => {
          const input = label.querySelector('input');
          if (!input) return;

          const available = this.variants.some(
            (variant) =>
              variant.available &&
              variant.options[optionIndex] === input.value &&
              variant.options.every(
                (option, index) => index === optionIndex || selected[index] == null || option === selected[index]
              )
          );

          label.classList.toggle('product-grid-item__option-pill--unavailable', !available);
        });
      });
    }

    updateVariantId(variant) {
      const input = this.card?.querySelector('input[name="id"]');
      if (input) input.value = variant.id;
    }

    updateImage(variant) {
      if (!variant.image || !this.card) return;

      const image = this.card.querySelector('.product-grid-item__featured-image img');
      if (!(image instanceof HTMLImageElement)) return;

      image.src = variant.image;
      image.srcset = variant.image;
    }

    updatePrice(variant) {
      const priceElement = this.card?.querySelector('.product-grid-item__price');
      if (!priceElement) return;

      if (variant.compareAtPrice) {
        priceElement.innerHTML =
          '<s class="strike-through mr-8">' +
          variant.compareAtPrice +
          '</s><span class="product__price">' +
          variant.price +
          '</span>';
      } else {
        priceElement.textContent = variant.price;
      }
    }

    updateButton(variant) {
      const button = this.card?.querySelector('button[name="add"]');
      if (!(button instanceof HTMLButtonElement)) return;

      button.disabled = !variant.available;

      const label = variant.available ? this.dataset.addText : this.dataset.soldOutText;
      const textContainer = button.querySelector('.add-to-cart-text__content');
      const target = textContainer?.querySelector('span span') || textContainer;
      if (target && label) target.textContent = label;
    }
  }

  if (!customElements.get('product-card-variants')) {
    customElements.define('product-card-variants', ProductCardVariants);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    class CollectionFilters extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.form.addEventListener('change', this.onChange.bind(this));
      this.form.addEventListener('input', this.onInput.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
    }

    disconnectedCallback() {
      clearTimeout(this._priceTimer);
    }

    onSubmit(e) {
      e.preventDefault();
      const url = new URL(this.form.action);
      const defaultSort = this.form.querySelector('[name="sort_by"]')?.dataset.default;
      new FormData(this.form).forEach((val, key) => {
        if (val === '') return;
        if (key === 'sort_by' && val === defaultSort) return;
        url.searchParams.set(key, val);
      });
      this.navigate(url.toString());
    }

    onChange(e) {
      if (e.target.type === 'checkbox' || e.target.tagName === 'SELECT') {
        this.form.requestSubmit();
      }
    }

    onInput(e) {
      if (!e.target.classList.contains('filter-price__input')) return;
      clearTimeout(this._priceTimer);
      this._priceTimer = setTimeout(() => this.form.requestSubmit(), 800);
    }

    onClick(e) {
      const link = e.target.closest('.filter-pill, .filter-clear-all');
      if (link) {
        e.preventDefault();
        this.navigate(link.href);
        return;
      }

      const toggle = e.target.closest('.filters-toggle');
      if (toggle) {
        const groups = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!groups) return;
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        groups.toggleAttribute('data-open', !open);
      }
    }

    async navigate(url) {
      if (this._loading) return;
      this._loading = true;

      try {
        const res = await fetch(url);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        this.swapLoadMore(doc);
        this.swap(doc, 'hommegirls-product-grid');
        history.pushState({}, '', url);
        window.scrollTo({ top: 0, behavior: 'smooth' });

        // Swap self last — disconnects this instance, new instance takes over
        const next = doc.querySelector('collection-filters');
        if (next) this.replaceWith(next);
      } catch {
        window.location = url;
      }
    }

    swap(doc, selector) {
      const next = doc.querySelector(selector);
      const curr = document.querySelector(selector);
      if (next && curr) curr.replaceWith(next);
    }

    swapLoadMore(doc) {
      const next = doc.querySelector('.collection__load-more')?.closest('p');
      const curr = document.querySelector('.collection__load-more')?.closest('p');
      if (curr && next) curr.replaceWith(next);
      else if (curr && !next) curr.remove();
      else if (!curr && next) document.querySelector('hommegirls-product-grid')?.after(next);
    }
  }

  customElements.define('collection-filters', CollectionFilters);
  } catch(e) { console.error(e); }
})();

})();
